var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolAccessPoint = function SvgFiremapSymbolAccessPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-11.618 2.041.35.959h1.9L10.16 9H8.328l-2.56 6H7.6l.36-.959zm-.471-1.3H8.456l.736-1.96zM13.071 9v6h1.78v-1.618h.941c1.55 0 2.44-.821 2.44-2.25 0-1.362-.89-2.132-2.44-2.132zm1.78 1.37h.856c.53 0 .838.29.838.813 0 .539-.308.83-.838.83h-.856z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolAccessPoint;